import svgArrows from 'Img/wizard-workflow-arrows.svg'
import {
  TEXT_VARIANT_LIGHT,
  TITLE_VARIANT_M,
  TooltipUtils
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { useIntl } from 'react-intl'
import * as S from './WorkflowBuilder.styles'

const WorkflowBuilderSidebar = ({ items }) => {
  const intl = useIntl()

  useEffect(() => {
    TooltipUtils.rebuild()
  })

  return (
    <Droppable droppableId='items' isDropDisabled>
      {(provided, snapshot) => (
        <S.Sidebar
          ref={provided.innerRef}
          isDraggingOver={snapshot.isDraggingOver}
        >
          <S.StyledTitle variant={TITLE_VARIANT_M}>
            {intl.formatMessage({
              id: 'Load.AutomationWorkflow.TitleDragAction'
            })}
          </S.StyledTitle>
          {items.map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.id}
              index={index}
              isDragDisabled={item.isDragDisabled}
            >
              {(provided, snapshot) => (
                <>
                  <S.SidebarItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    isDragging={snapshot.isDragging}
                    style={provided.draggableProps.style}
                    isDragDisabled={item.isDragDisabled}
                    data-tip={item.tip}
                  >
                    {item.label}
                  </S.SidebarItem>
                  {snapshot.isDragging && (
                    <S.SidebarItemClone>{item.label}</S.SidebarItemClone>
                  )}
                </>
              )}
            </Draggable>
          ))}
          <S.StyledText variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({
              id: 'Load.AutomationWorkflow.TextDragAction'
            })}
          </S.StyledText>
          <S.Arrows src={svgArrows} />
        </S.Sidebar>
      )}
    </Droppable>
  )
}

export default WorkflowBuilderSidebar

WorkflowBuilderSidebar.propTypes = {
  items: PropTypes.array
}
